import React, {useEffect, useState} from 'react';
import styled from "styled-components";
import {HelmetProvider, Helmet} from 'react-helmet-async';
import DoctorsDetails from "../../components/Doctors/DetailsPage";
import {useDispatch, useSelector} from "react-redux";
import {apiEndPoints} from "../../api/network/apiEndPoints";
import {fetchPosts} from "../../api/redux/doctors";
import {ApiParam as ApiParamKey} from "../../api/network/apiParams";
import {fetchChild} from "../../api/redux/doctors";
import {fetchDepartment} from "../../api/redux/appoinment";
import {useLocation} from "react-router-dom";

const DoctorsPageDetails = () => {

    const dispath = useDispatch()

    const getData = useSelector(state => state.doctorsReducer)
    const getDoctorData = useSelector(state => state.appointReducer)
    // api call
    useEffect(() => {
        let apiUrl = apiEndPoints.CHILD_PAGE
        let apiUrlSection = apiEndPoints.SECTIONS

        let api_params = {
            [ApiParamKey.page_id]: 30,
            [ApiParamKey.sections]: 'yes',
            [ApiParamKey.image]: 'yes',
            [ApiParamKey.post]: 'yes',
            [ApiParamKey.file]: 'no',
        }
        let api_params_sections = {
            [ApiParamKey.type]: 'slug',
            [ApiParamKey.value]: 'doctors',
            [ApiParamKey.get_section]: 'yes',
            [ApiParamKey.image]: 'yes',
            [ApiParamKey.post]: 'yes',
            [ApiParamKey.file]: 'no',
        }

        dispath(fetchChild([apiUrl, api_params]))
        dispath(fetchPosts([apiUrlSection, api_params_sections]))
        dispath(fetchDepartment([apiEndPoints.DOCTOR_LIST]))
    }, [])



    // filter data
    const DoctorsDetailss = getData?.posts?.doctors;

    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const initialDetails = queryParams.get('profile');

    const [profile, setProfile] = useState(initialDetails);
    const filteredData = DoctorsDetailss?.filter((item) => item.data?.slug === profile);




    const page_data = filteredData?.[0]?.data;
    return (

        <HelmetProvider>
            <Helmet>
                <title>{`${page_data?.title ? page_data?.title + ' | ' : ''}`}National Heart
                    Foundation</title>

                <meta name="meta:title" content={page_data?.meta_title}/>
                <meta name="description" content={page_data?.meta_description}/>
                <meta property="og:title" content={page_data?.og_title}/>
                <meta property="og:subtitle" content={page_data?.og_title}/>
                <meta property="og:description" content={page_data?.og_description}/>
                <meta property="og:image" content={filteredData?.[0]?.images?.list?.[0]?.full_path}/>
                <meta property="og:url" content={window?.location?.href}/>
                <meta property="og:type" content={"website"}/>
            </Helmet>

            <StyledComponent>

                {
                    DoctorsDetailss &&
                    <DoctorsDetails data={DoctorsDetailss}/>
                }

                {/*<DoctorsPublications/>*/}
            </StyledComponent>
        </HelmetProvider>

    );
};

const StyledComponent = styled.section`

`;

export default DoctorsPageDetails;
